<template xmlns="http://www.w3.org/1999/html">
  <div id="result-list" class="result-list">
    <section :class="`result-panels ${mapStateClass}`">
      <!-- List of apartments -->
      <div id="result-list-scroller" class="result-panel list" @scroll.passive="onScroll">
        <results-header
          :locationTotalCount="locationTotalCount"
          :locationCount="listings && listings.length"
          :filters="filters"
        ></results-header>

        <div class="result-card-wrapper">
          <template v-for="listing in listings" :key="`listing-id-${listing.id}`">
            <condominium-result
              v-if="listing.newHousing && listing.newHousing.newHousingId === listing.id"
              :hoverOff="isHoverOff()"
              :listing="listing"
              :isSelected="highlightedItem === listing.id"
              @hoverResult="hoverResult"
              @focus="onListingFocus(listing.id)"
            ></condominium-result>
            <listing-result
              v-else
              :hoverOff="isHoverOff()"
              :listing="listing"
              :rentalMode="filters.mode === config.SEARCH_MODES.RENTAL"
              :isSelected="highlightedItem === listing.id"
              @hoverResult="hoverResult"
              @focus="onListingFocus(listing.id)"
            ></listing-result>
          </template>
        </div>

        <div class="result-more">
          <div v-if="isFetching">
            <clip-loader :color="spinnerColor" :size="spinnerSize"></clip-loader>
          </div>
        </div>

        <div class="search-prompt" v-if="listings.length === 0">
          <p>
            <span>Antamillasi hakuehdoilla ei löytynyt kohteita.</span>
            <span>Kokeile muuttaa ehtoja tai etsiä laajemmalta alueelta!</span>
          </p>
        </div>

        <div class="back-to-beginning-button" v-if="showScrollToTop" @click="scrollToTop">
          <i class="icon-chevron-up"></i>
        </div>
      </div>

      <!-- Apartments on map -->
      <div :class="getMapPanelClass">
        <results-header
          :locationTotalCount="locationTotalCount"
          :locationCount="listings && listings.length"
        ></results-header>
        <keep-alive>
          <apartment-map
            :showToggleButton="true"
            v-bind:listings="listings"
            @toggleMap="setMapStateClass($event)"
            @setHighlightedItem="highlightedItem = $event"
            @removeHighlightedItem="highlightedItem = null"
          ></apartment-map>
        </keep-alive>
      </div>
    </section>

    <spinner></spinner>
  </div>
</template>

<script>
import ListingResult from '../listing-result/listing-result.vue';
import ApartmentMap from '../apartment-map/apartment-map.vue';
import Expander from '../expander/expander.vue';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import config from '@/config';
import ResultsHeader from './results-header.vue';
import CondominiumResult from '../listing-result/listing-result-condominium.vue';
import Spinner from '@/app/components/spinner/spinner.vue';

export default {
  name: 'result-list',
  data: () => ({
    config,
    scrolledElement: null, // Either result-list-scroller or document.documentElement depending on breakpoint width
    showScrollToTop: false,
    isScrolling: false,
    spinnerColor: '#cccccc',
    spinnerSize: '40px',
    mapStateClass: 'map-expanded',
    isMobile: false,
    highlightedItem: null,
  }),
  props: {
    listings: {
      type: Object,
      required: true,
    },
    locationTotalCount: {
      type: Number,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    isFetching: {
      type: Boolean,
      required: true,
    },
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    clearTimeout(this.scrollTimeout);
    clearTimeout(this.hoverTimeout);
    clearTimeout(this.unhoverTimeout);
  },
  mounted() {
    this.isMobile = window.innerWidth < config.BREAKPOINTS.TABLET_PORTRAIT;
    window.addEventListener('scroll', this.onScroll); // Page scroll on mobile without result-list-scroller
  },
  methods: {
    onListingFocus(listingId) {
      // fetches more listings when the second last listing is focused
      const secondLastId = this.listings[this.listings.length - 2]?.id;
      if (listingId === secondLastId) {
        this.$emit('onEndReached');
      }
    },
    onScroll(event) {
      this.isScrolling = true;
      this.scrolledElement = event.target instanceof Element ? event.target : document.documentElement;
      const scrollTop = this.scrolledElement.scrollTop;
      const scrollHeight = this.scrolledElement.scrollHeight;
      const clientHeight = this.scrolledElement.clientHeight;

      const buffer = 50; // To avoid small pixel differences breaking the check and to make fetching smoother
      const isAtBottom = scrollHeight - scrollTop <= clientHeight + buffer;
      this.showScrollToTop = scrollTop > 200 ? true : false;
      if (isAtBottom) {
        this.$emit('onEndReached');
      }

      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isScrolling = false;
      }, 100);
    },
    scrollToTop() {
      this.scrolledElement.scrollTo({
        top: 0,
      });
    },
    isHoverOff() {
      return this.mapStateClass !== 'map-expanded';
    },
    setMapStateClass(value) {
      this.mapStateClass = value ? 'map-expanded' : '';
    },
    hoverResult(listingId) {
      this.elementHasHover = !!listingId;

      if (this.isHoverOff()) {
        return;
      }

      // Mouse is entering result
      if (listingId) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(() => {
          if (!this.isScrolling) {
            this.$bus.$emit('hoverSearchResult', listingId);
          }
        }, 100);
      }
      // Mouse is leaving result
      else {
        clearTimeout(this.unhoverTimeout);
        this.unhoverTimeout = setTimeout(() => {
          if (!this.isScrolling) {
            this.$bus.$emit('hoverSearchResult', false);
          }
        }, 100);
      }
    },
  },
  computed: {
    getMapPanelClass() {
      return this.isMobile ? 'result-panel map mobile' : 'result-panel map';
    },
  },
  components: {
    CondominiumResult,
    ResultsHeader,
    ListingResult,
    ApartmentMap,
    Expander,
    Spinner,
    ClipLoader,
  },
};
</script>
